import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

interface IMeasurementFieldPayload {
  id?: string;
  measurement_field_name: string;
  measurement_unit: string;
  measurement_field_image_url: string;
}

export const GET_ALL_MEASUREMENT_FIELD = (
  pagination: IPagination,
  search: string
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_measurement_field.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }`,
    API_ENDPOINTS.get_all_measurement_field.method
  );

export const DELETE_MEASUREMENT_FIELD = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_measurement_field.url + `/${id}`,
    API_ENDPOINTS.delete_measurement_field.method
  );
};

export const GET_MEASUREMENT_FIELD_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_measurement_field.url + `/${id}`,
    API_ENDPOINTS.get_all_measurement_field.method
  );
};

export const CREATE_MEASUREMENT_FIELD = (payload: IMeasurementFieldPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_measurement_field.url,
    API_ENDPOINTS.create_measurement_field.method,
    payload
  );
};

export const UPDATE_MEASUREMENT_FIELD = (
  payload: IMeasurementFieldPayload,
  id: string
) => {
  return serviceMaker(
    API_ENDPOINTS.update_measurement_field.url + `/${id}`,
    API_ENDPOINTS.update_measurement_field.method,
    payload
  );
};
